export const FieldActivityTypesSeeding = {
  standard_seeding: {},
  direct_seeding: {},
  dry_seeding: {},
  submerged_seeding: {},
};
